import globalLoading from "#components/globalLoading";
import withFunctionCall from "#utils/withFunctionCall";
import { Alert, Form, Input, Modal, Radio } from "@bedrock/components"
import React from "react"

interface NodeBackModalProps {
  onOk: (data: { reason?: string }) => void;
  onCancel?: () => void;
  headerPlace?: React.ReactNode;
  reasonLabel?: string;
  reasonRequired?: boolean;
  reasonCompProps?: React.ComponentProps<typeof Input.TextArea>;
  nodeOptions?: { name: string; value: string }[];
  message?: string;
  showReason?: boolean;
}

const NodeBackModal = (props: React.ComponentProps<typeof Modal> & NodeBackModalProps) => {
  const { headerPlace, reasonLabel = '退回原因', reasonRequired = true,  reasonCompProps = { maxLength: 200 }, nodeOptions = [], message = '确定退回此单吗？', showReason = true,  ...rest } = props;

  const [form] = Form.useForm();

  const handleOk = async () => {
    const data = await form.validateFields();
    globalLoading.show();
    try {
      await props.onOk(data);
      props.onCancel?.();
    } catch (error) {
      console.log(error);
    }
    globalLoading.done();
  }

  return (
    <Modal
      destroyOnClose
      maskClosable={false}
      title="退回"
      width={480}
      okText='确定退回'
      okButtonProps={{
        danger: true,
      }}
      {...rest}
      onOk={handleOk}
    >
      {headerPlace || <Alert type='warning' showIcon message={message} className='m-b-24' />}
      <Form form={form} showLabelColon layout='vertical'>
        {!!nodeOptions?.length && <Form.Item rules={[{ required: true, message: '请选择' }]} label={'退回节点'} name="target_state">
          <Radio.Group options={nodeOptions} />
        </Form.Item>}
        {showReason && <Form.Item rules={[{ required: reasonRequired, message: '请输入' }]} label={reasonLabel} name="reason">
          <Input.TextArea className="w-full" showCount {...reasonCompProps} />
        </Form.Item>}
      </Form>
    </Modal>
  )
}

export default withFunctionCall(NodeBackModal);